/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getOauthConfig} from '../api'

 export const useQueryGetOauthConfig = createReactQueryHook('getOauthConfig', getOauthConfig)
